import { Context } from '@cog/ecs'

import { Timer } from '../Components/Timer'


export const cleanupDeadTimers = <C extends Context>(ctx: C) => {
  ctx.world.deleteWhere([Timer], (args) => args[0].current <= 0.0)
}
